import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationBarService {
  private sideNavBarSubject = new BehaviorSubject<boolean>(true);
  public sideNavBar$ = this.sideNavBarSubject.asObservable();
  constructor() {}

  public show(flag: boolean): void {
    this.sideNavBarSubject.next(flag);
  }
}
